module.exports = __webpack_public_path__ + "static/img/win.b0f1df1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/win_lose/win.png
// module id = rrnw
// module chunks = 1